<template>
  <div class="contentBox" :class="device=='mobile'?'mobileBox':''">
    <web ref="web" class="webBox"></web>
    <button class="btn btn-back" @click="goBack"></button>
    <button class="btn btn-count" @click="resultSub"></button>
    <p class="title">{{titleData.title}}</p>
    <p class="msg">距离结营时间还剩:<span>{{titleData.diff_day}}</span>天</p>
    <div class="list" v-if="titleData.type == 1">
      <div class="list-item list-item1" @click="videoSub"></div>
      <div class="list-item list-item2" @click="examSub"></div>
      <div class="list-item list-item3" @click="wrongSub"></div>
    </div>
    <div class="list" v-else>
      <div class="list-item list-item4" @click="examSub"></div>
    </div>
  </div>
</template>
<script>
import { getArticleDetail } from "@/assets/js/api";
import web from './../components/comment/web.vue';
export default {
  name: "login",
  data() {
    return {
      identityID:'',
      token:'',
      titleData:'',
      device:''
    };
  },
  components: {
    web
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.getDetail();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    }
  },
  methods: {
    identitySub(e){
      this.identityID = e;
    },

    async getDetail(){
      var that = this;
      try {
        const response = await getArticleDetail({rmid:this.$route.query.rmid},this.token);
        if(response.code == 200){
          that.titleData = response.data;
          document.title = that.titleData.title;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    videoSub(){
      this.$router.push('/identityVideo?rmid='+this.$route.query.rmid)
    },

    examSub(){
      this.$router.push('/exam?rmid='+this.$route.query.rmid)
    },

    wrongSub(){
      this.$router.push('/wrong?rmid='+this.$route.query.rmid)
    },

    resultSub(){
      this.$router.push('/result?rmid='+this.$route.query.rmid)
    },

    goBack() {
      var that = this;
      that.$router.go(-1);
      setTimeout(function(){
        window.location.reload();
      },100)
    }
  },

  
};
</script>
<style scoped>
  .contentBox{
    background-image: url(~@/assets/images/index-bg.png);
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    padding: 112px 0 45px;
  }

  .title{
    color: #333333;
    font-size: 40px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .btn-back{
    background-image: url(~@/assets/images/btn-bg1.png);
  }

  .btn-count{
    position: absolute;
    top: 50px;
    right: 60px;
    background-image: url(~@/assets/images/icon-bg4.png);
    width: 200px;
    height: 80px;
    background-size: 200px 80px;
  }

  .msg{
    font-size: 30px;
    color: #333333;
    margin-top: 10px;
    display: block;
    text-align: center;
  }

  .msg span{
    color: #FF3232;
  }

  .list{
    font-size: 0;
    text-align: center;
    margin-top: 50px;
  }

  .list .list-item{
    display: inline-block;
    vertical-align: top;
    width: 371px;
    height: 465px;
    background-size: 371px 465px;
  }

  .list .list-item.list-item1{
    background-image: url(~@/assets/images/icon1.png);
  }
  .list .list-item.list-item2{
    background-image: url(~@/assets/images/icon2.png);
    margin: 0 118px;
  }
  .list .list-item.list-item3{
    background-image: url(~@/assets/images/icon3.png);
  }
  .list .list-item.list-item4{
    background-image: url(~@/assets/images/icon21.png);
  }
  .contentBox.mobileBox{
    padding: .22rem;
  }
  .mobileBox .btn-count{
    width: 1.51rem;
    height: .57rem;
    background-size: 1.51rem .57rem;
    top: .2rem;
    right: .3rem;
  }

  .mobileBox .btn-back{
    height: .52rem;
    width: .52rem;
    background-size: .52rem .52rem;
  }

  .mobileBox .title{
    font-size: .3rem;
  }

  .mobileBox .msg{
    font-size: .24rem;
    color: #777777;
    margin-top: .1rem;
  }

  .mobileBox .list .list-item{
    width: 2.17rem;
    height: 2.95rem;
    background-size: 2.17rem 2.95rem;
  }

  .mobileBox .list .list-item.list-item1{
    background-image: url(~@/assets/images/ipad/list-icon2.png);
  }
  .mobileBox .list .list-item.list-item2{
    background-image: url(~@/assets/images/ipad/list-icon3.png);
    margin: 0 .25rem;
  }
  .mobileBox .list .list-item.list-item3{
    background-image: url(~@/assets/images/ipad/list-icon4.png);
  }
</style>



// WEBPACK FOOTER //
// src/identity/list.vue